import React, { useState , useEffect } from 'react'
import Header from '../Partials/Header'
import Footer from '../Partials/Footer'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import {
    collection,
    getDocs,
    query,
    where,
    doc,
    updateDoc,
    serverTimestamp,
    Timestamp,

  } from "firebase/firestore";
  import { db } from "../firebase/firebase";


const MyAppointment = () => {
    const [formData, setFormData] = useState({ email: "", appId: "" });

    const navigate = useNavigate()

    const inputChange = e => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    }

    const submitHandler = async (e) => {
        e.preventDefault();

        if (formData.email.trim().length === 0) {
            toast.error("Please, enter email", { position: "top-center", autoClose: 2000 });
            return;
        }
        if (formData.appId.trim().length === 0) {
            toast.error("Please, enter appointment ID", { position: "top-center", autoClose: 2000 });
            return;
        }

        try {
            // Query Firestore to check if the email and appointment ID match
            const q = query(
                collection(db, "appointments"), // Replace with your collection name
                where("email", "==", formData.email),
                where("appId", "==", formData.appId)
            );

            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                toast.error("Email or Appointment Id is incorrect.", { position: "top-center", autoClose: 2000 });
                return;
            }

            // If match found, navigate to chat page
            navigate("/chat", { state: { appId: formData.appId } });
            sessionStorage.setItem("login",1);
            // window.location  .reload();
        } catch (error) {
            console.error("Error checking appointment:", error);
            toast.error("Error verifying appointment. Please try again.", {
                position: "top-center",
                autoClose: 2000,
            });
        }
    };


    useEffect(() => {
        const storedData = localStorage.getItem("appointment_detail_id")
        if (storedData) {
            const data = JSON.parse(storedData)
            setFormData({ email: data.email, appId: data.appId });
        }

    }, [])

    return (
        <>
            <Header />
            <div className="container d-flex align-items-center" style={{ marginBottom: '11%', marginTop: '7%', minHeight: "50vh" }}>
                <div className='col-12'>
                    <div className=''>
                        <form onSubmit={submitHandler}>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input type="email" className="form-control" name='email' id="email" value={formData.email ? formData.email : '' } onChange={inputChange} placeholder="Enter your email" required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="appId">Appointment ID</label>
                                <input type="text" name='appid' className="form-control" id="appId" value={formData.appId ? formData.appId : ''} onChange={inputChange} placeholder="Enter your appointment ID" required />
                            </div>
                            <button type="submit" className="btn btn-primary btn-block">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default MyAppointment